<template lang='pug'>
.interaction-wrapper(v-if='list.length')
    .panel(v-for='item in list' :key="item.id" @click='goLink(item)')
        img(v-src='item.detail.banner')
        .text {{ item.name }}
    //- router-link.panel(:to='{ name: "news" }')
    //-     img(v-src='"https://oss.cloud.custouch.com/res/13000/市场动态.jpg"')
    //-     .text 市场动态
    //- a.panel(
    //-     href=' https://mp.weixin.qq.com/s?__biz=MzA5NDEzNzc4OA==&mid=503044068&idx=1&sn=70515d7c13e1f38220b8aa4b72cff0bb&chksm=085c4b373f2bc22190320e5b30ba2e14410d78dcd55e7c003773fa5dad27a2982a21e0a7bded&scene=18&xtrack=1&key=360754e56e0333194721502a6e6c058fe913520893fe287c18e6721833265d33b246a3b5059fbf6265bc72710d83ae77acd878ed9efae1b2b37ab02a23db881de8121f08b06da5cdd35db6f8dbc84e16b8dbf692781cd5229c109ce10a4307a0a6207b66c437a1a3129449c3b18e193d044fe8ce4bc01ee183dee45bc019bbe2&ascene=1&uin=MzQ3MTE5ODU1&devicetype=Windows+10+x64&version=62090529&lang=zh_CN&exportkey=AeguX7s7nqo0r6DOLRTLTPc%3D&pass_ticket=61A0Wx19QhRM3eOsFQjDQzN6uFwPz%2BjqO5tdnxQCR%2BmXnGSDdcr%2BsC5p2QzxNYll'
    //- )
    //-     img(
    //-         v-src='"https://oss.cloud.custouch.com/res/11952/after_sale.png"'
    //-     )
    //-     .text 质保服务
    //- router-link.panel(:to='{ name: "contactUs" }')
    //-     img(
    //-         v-src='"https://oss.cloud.custouch.com/res/12996/联系我们.jpg"'
    //-     )
    //-     .text 联系我们
</template>

<script>
import anime from 'animejs'
import { getDataHierarchies } from '@custouch/proxy-use'
export default {
    data(){
        return {
            list: []
        }
    },
    async mounted() {
        const { DATA } = window.env
        const { module } = DATA
        const ret = await getDataHierarchies(module.interaction.id)
        this.list = ret
        this.$nextTick(()=>{
            anime({
                targets: '.panel img',
                opacity: [0, 1],
                duration: 500,
                borderRadius: ['50%', 0],
                delay: anime.stagger(150),
                easing: 'easeInSine'
            })
        })
    },
    methods: {
        goLink(item){
            if(item.detail.link){
                window.location.href = item.detail.link
                this.$message.loading({
                    message: '跳转中...',
                    forbidClick: true,
                    duration: 3000
                })
                return
            }
            const { DATA } = window.env
            const { module } = DATA
            if(item.id === module.interaction.hierarchies.news){
                this.$router.push({
                    name: 'news'
                })
            }else if(item.id === module.interaction.hierarchies.contactUs){
                this.$router.push({
                    name: 'contactUs'
                })
            }
        }
    }
}
</script>

<style scoped lang='less'>
.interaction-wrapper {
    padding: 1.2rem 1rem;
    .panel {
        display: block;
        width: 100%;
        margin-bottom: 1.2rem;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        img {
            opacity: 0;
            width: 100%;
            height: 5.85rem;
            object-fit: cover;
        }
        .text {
            line-height: 1.7rem;
            text-align: center;
            width: 100%;
        }
    }
}
</style>